import axios from 'axios';
import useAuthStore from '../../store/authStore';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL_ADMIN || 'http://localhost:4000/api/admin',
  withCredentials: true,
});

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      useAuthStore.getState().clearUser();
    }
    return Promise.reject(error);
  }
);

export const createSeries = async (formData) => {
  const form = new FormData();
  
  // Append all text fields
  Object.keys(formData).forEach(key => {
    if (key !== 'cover_image' && formData[key] !== null) {
      if (Array.isArray(formData[key])) {
        form.append(key, JSON.stringify(formData[key]));
      } else {
        form.append(key, formData[key]);
      }
    }
  });

  // Append cover image if it exists
  if (formData.cover_image) {
    form.append('cover_image', formData.cover_image);
  }

  const response = await api.post('/series', form, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

export const updateSeries = async ({ id, formData }) => {
  const form = new FormData();
  
  Object.keys(formData).forEach(key => {
    if (key !== 'cover_image' && formData[key] !== null) {
      if (Array.isArray(formData[key])) {
        form.append(key, JSON.stringify(formData[key]));
      } else {
        form.append(key, formData[key]);
      }
    }
  });

  if (formData.cover_image) {
    form.append('cover_image', formData.cover_image);
  }

  const response = await api.put(`/series/${id}`, form, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

export const getSeries = async () => {
  const response = await api.get('/series');
  return response.data;
};

export const getSeriesById = async (id) => {
  const response = await api.get(`/series/${id}`);
  return response.data;
};

export const deleteSeries = async (id) => {
  const response = await api.delete(`/series/${id}`);
  return response.data;
};

export const getSeriesByType = async (series_type) => {
  if (!series_type) {
    throw new Error('Series type is required');
  }
  const response = await api.get(`/series/by-type?series_type=${series_type}`);
  return response.data;
};